"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._getUpgradeSourceFromLocation = void 0;

var _params = require("hub-http/helpers/params");

var _reactRouterDom = require("react-router-dom");

var _getUpgradeSourceFromLocation = function _getUpgradeSourceFromLocation(location) {
  var upgradeSource;

  if (location) {
    var query = (0, _params.parse)(location.search.slice(1));

    if (query) {
      if (query.upgradeSource) {
        upgradeSource = decodeURIComponent(query.upgradeSource);
      } else if (query.upgradesource) {
        // shortlinks will lowercase passthrough query params so we have to check both
        upgradeSource = decodeURIComponent(query.upgradesource);
      }
    }
  }

  return upgradeSource;
};

exports._getUpgradeSourceFromLocation = _getUpgradeSourceFromLocation;

var _default = function _default() {
  return _getUpgradeSourceFromLocation((0, _reactRouterDom.useLocation)());
};

exports.default = _default;